import type {
	IPropsStore,
	TpaHandlerProvider,
	ViewerModel,
	AppStyleProps,
	AppWidgetData,
	Experiments,
} from '@wix/thunderbolt-symbols'
import {
	MasterPageFeatureConfigSymbol,
	PageFeatureConfigSymbol,
	Props,
	ExperimentsSymbol,
} from '@wix/thunderbolt-symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { IOoiTpaSharedConfig } from 'feature-ooi-tpa-shared-config'
import { OoiTpaSharedConfigSymbol } from 'feature-ooi-tpa-shared-config'
import type { ICommonConfig } from 'feature-common-config'
import { CommonConfigSymbol } from 'feature-common-config'
import type { ITpaLoadMeasure, TpaMasterPageConfig, TpaPageConfig } from '../types'
import { name, TpaLoadMeasureSymbol } from '../symbols'

export type MessageData = { version: string }

export type AppIsAliveResponse = AppStyleProps &
	AppWidgetData & {
		fonts: { cssUrls: any; imageSpriteUrl: string; fontsMeta: any }
		commonConfig: ViewerModel['commonConfig']
		isVisualFocusEnabled: boolean
		siteColors: any
		siteTextPresets: any
	}

export const AppIsAliveHandler = withDependencies(
	[
		named(MasterPageFeatureConfigSymbol, name),
		named(PageFeatureConfigSymbol, name),
		TpaLoadMeasureSymbol,
		CommonConfigSymbol,
		Props,
		OoiTpaSharedConfigSymbol,
		ExperimentsSymbol,
	],
	(
		tpaMasterPageConfig: TpaMasterPageConfig,
		{ widgets }: TpaPageConfig,
		tpaLoadMeasure: ITpaLoadMeasure,
		commonConfigAPI: ICommonConfig,
		props: IPropsStore,
		{ getFontsConfig }: IOoiTpaSharedConfig,
		experiments: Experiments
	): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				appIsAlive(compId: string, msgData, { originCompId }): AppIsAliveResponse {
					const { siteColors, isVisualFocusEnabled, siteTextPresets } = tpaMasterPageConfig
					props.update({
						[compId]: {
							sentAppIsAlive: true,
						},
					})
					tpaLoadMeasure.reportTpaLoadEnd(compId)
					const widgetData = widgets[originCompId] || {
						style: {
							colors: {},
							numbers: {},
							booleans: {},
							fonts: {},
							strings: {},
							googleFontsCssUrl: '',
							uploadFontFaces: '',
						},
					}
					const fontsConfig = getFontsConfig()

					/*
					 * Note: CSS for WIX iFrame TPAs should be inlined, so no need to supply CSS as external files
					 * it helps to prevent INP degradation for WIX sites
					 * Required fonts CSS is added to "widgetData.style.uploadFontFaces"
					 * */
					if (widgetData.isWix) {
						fontsConfig.cssUrls = []
					}

					return {
						fonts: fontsConfig,
						commonConfig: commonConfigAPI.getCommonConfig(),
						isVisualFocusEnabled,
						siteColors,
						siteTextPresets,
						...widgetData,
					}
				},
			}
		},
	})
)
